<template>
  <v-container>
    <v-row>
      <v-col class="d-flex align-start mb-6">
        <span class="text-left">
          {{ `${numText}: ${questionText}` }}
        </span>
        <span v-if="required" class="red--text text--lighten-1">*</span>
      </v-col>
      <v-col>
        <v-radio-group v-model="response" class="pa-0 ma-0" @change="show">
          <v-radio
            v-for="(option, i) in options"
            :key="i"
            :label="`${option}`"
            :value="i"
            color="#1791b1"
          />
        </v-radio-group>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'MonoSelector',
  props: {
    questionText: {
      type: String,
      required: true
    },
    numText: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    required: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      response: '',
      question: {}
    }
  },
  methods: {
    show: function (option) {
      this.$emit('update', String(option + 1))
    }
  }
}
</script>
